import { formatAmount } from "../format.ts";
import { CurrencyInput } from "./CurrencyInput.tsx";

type Props = {
  value: number;
  projection: number;
  onChange: (n: number) => void;
  onEnter: () => void;
};

export function StartBalance({ value, projection, onChange, onEnter }: Props) {
  return (
    <div className="start-balance">
      <label htmlFor="start-balance-input">Startsaldo</label>
      <CurrencyInput
        id="start-balance-input"
        value={value}
        onChange={onChange}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onEnter();
          }
        }}
      />
      <span className={`projection${projection < 0 ? " neg" : ""}`}>
        Prognos: <b>{formatAmount(projection)}</b>
      </span>
    </div>
  );
}
